import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetProvidersMedicalGuideModelV3,
	GetProvidersMedicalGuideV3,
	GetProvidersMedicalGuideParamsV3,
} from 'domain/usecases/private/guide-flow/medical-guide/get-providers-v3';

export class RemoteGetProvidersMedicalGuideV3 implements GetProvidersMedicalGuideV3 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProvidersMedicalGuideModelV3>,
	) {}

	async get({
		signal,
		...params
	}: GetProvidersMedicalGuideParamsV3): Promise<GetProvidersMedicalGuideModelV3> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
